import React from 'react';
import Table from '@/common/components/Table';
import ActionButton from '@/common/components/buttons/ActionButton';
import { Colors } from '@/common/colors/colors';
import { PAGE_SIZE } from '../../hooks/useCallAnalysis';
import {
	PaginationButtons,
	PaginationInfo,
	PaginationWrapper,
} from '../../callAnalysis.styles';
import { HEADERS } from './constants/headers';
import { getRaws } from './helpers/getRaws';

const CallAnalysisTable = ({
	items,
	total,
	page,
	totalPages,
	onOpen,
	onAnalyze,
	onPageChange,
}) => (
	<div style={{ width: '100%', maxWidth: 1200 }}>
		<p style={{ color: Colors.darkBlue }}>Found: {total}</p>
		<Table
			className='styled-table'
			headers={HEADERS}
			raws={getRaws({ items, page, onOpen, onAnalyze })}
		/>
		{!!items.length && (
			<PaginationWrapper>
				<PaginationInfo>
					Page {page} of {totalPages} · max {PAGE_SIZE} results
				</PaginationInfo>
				<PaginationButtons>
					<ActionButton
						defaultText='<'
						disabled={page <= 1}
						onClick={() => onPageChange(page - 1)}
					/>
					<ActionButton
						defaultText='>'
						disabled={page >= totalPages}
						onClick={() => onPageChange(page + 1)}
					/>
				</PaginationButtons>
			</PaginationWrapper>
		)}
	</div>
);

export default CallAnalysisTable;
